module.exports = __webpack_public_path__ + "img/course97_summary_unit_timelines.deee85ea.png";